import { useTranslation } from "react-i18next";
import type { CustomerStatus } from "@/features/customers/types";

// Status badge (dot + label). Handoff mapping:
//   active = green · inactive = grey · new = blue
const STYLES: Record<CustomerStatus, string> = {
  active: "bg-green-bg text-green-dark",
  inactive: "bg-grey-100 text-grey-600",
  new: "bg-blue-bg-soft text-blue",
};

export function StatusBadge({ status }: { status: CustomerStatus }) {
  const { t } = useTranslation();
  const cls = STYLES[status] ?? STYLES.inactive;
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-pill px-2 py-[3px] text-[12.5px] font-semibold leading-[1.4] ${cls}`}
    >
      <span className="h-1.5 w-1.5 flex-none rounded-pill bg-current" />
      {t(`status.${status}`)}
    </span>
  );
}
